// src/components/VideoPlayer.js
import React, { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { IoClose } from "react-icons/io5";
import useFetch from '../ApiClient/GetApi';
import './VideoPlayer.css';

const VideoPlayer = ({ url }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [isVisible, setIsVisible] = useState(true); // State to control visibility of the player
    const { apiData } = useFetch("/admin/uploadedVideo");
    // console.log(apiData?.data?.video);


    const nodeRef = useRef(null);
    useEffect(() => {
        // Trigger video play once the component mounts
        setIsPlaying(true);
    }, []);

    // Function to close the video player
    const handleClose = () => {
        setIsVisible(false);
    };

    return (
        isVisible && (
            <Draggable nodeRef={nodeRef} >
                <div className="video-player-container" ref={nodeRef} >
                    {
                        apiData?.data?.video?.video &&
                        <div>
                            <video width="320" height="180" controls>
                                <source src={apiData?.data?.video?.video} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <button
                                onClick={handleClose}
                                className="close-button"
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "0px",
                                    width: "30px",
                                    height: "30px",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <IoClose size={18} />
                            </button>

                        </div>
                    }
                </div>
            </Draggable>
        )
    );
};

export default VideoPlayer;
